import { Injectable, inject, signal } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { firstValueFrom, catchError, of } from "rxjs";

@Injectable({ providedIn: "root" })
export class FeatureFlagsService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = '/api/config/feature-flags';
  private readonly flags = signal<Record<string, boolean>>({});

  private readonly defaultFlags: Record<string, boolean> = {
    'catalog.linked_products_view.enabled': true,
  };

  async load(): Promise<void> {
    try {
      const data = await firstValueFrom(
        this.http.get<Record<string, boolean>>(this.apiUrl)
          .pipe(catchError(() => of(this.defaultFlags)))
      );
      this.flags.set(data ?? this.defaultFlags);
    } catch {
      this.flags.set(this.defaultFlags);
    }
  }

  refresh(): Promise<void> {
    return this.load();
  }

  isEnabled(key: string): boolean {
    return this.flags()[key] === true;
  }

  getFlags(): Record<string, boolean> {
    return { ...this.flags() };
  }
}
